import { Component, Input, ChangeDetectionStrategy,
         ChangeDetectorRef } from '@angular/core';
import { DataSource } from '../../datasource';


@Component({
  selector: 'igo-ogc-filterable-list',
  template: require('./ogc-filterable-list.component.html'),
  styles: [require('./ogc-filterable-list.component.styl')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OgcFilterableListComponent {

  @Input()
  get datasources(): DataSource[] { return this._dataSources; }
  set datasources(value: DataSource[]) {
    this._dataSources = value;
    this.cdRef.detectChanges();
  }
  private _dataSources: DataSource[] = [];

  constructor(private cdRef: ChangeDetectorRef) {}

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/filter/ogc-filterable-list/ogc-filterable-list.component.ts